cb.define(['common/common_VM.Extend.js'], function(common) {
	var ST_st_stockanalysis_filterVM_Extend = {
		doAction: function(name, viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function(viewmodel) {
			viewmodel.on("afterInit", function() {
				debugger
				//仓库过滤条件只显示门店仓*/
				var conditionWarehouse = {
					"isExtend": true,
					simpleVOs: []
				};
				//var storeid = cb.rest.AppContext.user.storeId;
				conditionWarehouse.simpleVOs.push({
					field: 'wStore',
					op: 'eq',
					value1: true
				});
				viewmodel.get('warehouse_name').getFromModel().setFilter(conditionWarehouse);
				//参照过滤掉服务商品
				var conditionProduct = {
					"isExtend": true,
					simpleVOs: []
				};
				//var storeid = cb.rest.AppContext.user.storeId;
				conditionProduct.simpleVOs.push({
					field: 'virtualProductAttribute',
					op: 'eq',
					value1: 0
				});
				viewmodel.get('product.cName').getFromModel().setFilter(conditionProduct);
				viewmodel.get('productsku.skuName').getFromModel().setFilter(conditionProduct);

				
				//选择仓库之前，如果选择门店，按照门店过滤,否则根据当前用户有权限的门店进行过滤
		        viewmodel.get("warehouse_name").getFromModel().on('beforeBrowse', function (data) {
		          var promise = new cb.promise();
		          var store_ids = [];
		          if (viewmodel.get("store_name").getData().value1 != null && viewmodel.get("store_name").getData().value1 != "" && viewmodel.get("store_name").getData().value1.length != 0) {
		            store_ids = viewmodel.get("store_name").getData().value1;
		          } else {
		            var userStores = cb.rest.AppContext.user.userStores;
		            if (userStores != null && userStores != "" && userStores.length != 0) {
		              for (var i = 0; i < userStores.length; i++) {
		                store_ids.push(userStores[i].store);
		              }
		            }
		          }
		          if (store_ids != null && store_ids != "" && store_ids.length != 0) {
		            var proxy = cb.rest.DynamicProxy.create({
		              settle: {
		                url: "/bill/ref/getWarehousesFromStores",
		                method: "POST"
		              }
		            });
		            var params = {
		              storeIds: store_ids,
		            };
		            proxy.settle(params, (err, result) => {
		              if (err) {
		                cb.utils.alert(err.message, 'error');
		              }
		
		              if (result === undefined || result.length == 0) {
		                cb.utils.alert("没有查询到当前选择店铺的仓库！", 'error');
		              } else {
		                var conditionWarehouse = {
		                  "isExtend": true,
		                  simpleVOs: []
		                };
		                //门店下的仓库
		                conditionWarehouse.simpleVOs.push({
		                  field: 'id',
		                  op: 'in',
		                  value1: result
		                });
		                //门店仓
		                conditionWarehouse.simpleVOs.push({
		                  field: 'wStore',
		                  op: 'eq',
		                  value1: true
		                });
		                viewmodel.get('warehouse_name').getFromModel().setFilter(conditionWarehouse);
		                promise.resolve();
		              }
		            });
		          } else {
		            cb.utils.alert("无门店权限！", 'error');
		          }
		          return promise;
		        });
		        
		        //门店过滤
		        viewmodel.get("store_name").getFromModel().on('beforeBrowse', function (data) {
		          //只能参照到当前用户有权限的门店
		          var userStores = cb.rest.AppContext.user.userStores;
		          var store_ids = [];
		          if (userStores != null && userStores != "" && userStores.length != 0) {
		            for (var i = 0; i < userStores.length; i++) {
		              store_ids.push(userStores[i].store);
		            }
		            var conditionStore = {
		              "isExtend": true,
		              simpleVOs: []
		            };
		
		            conditionStore.simpleVOs.push({
		              field: 'id',
		              op: 'in',
		              value1: store_ids
		            });
		            viewmodel.get('store_name').getFromModel().setFilter(conditionStore);
		          } else {
		            cb.utils.alert("无门店权限！", 'error');
		            return false;
		          }
		        });
				
				
				//门店变化以后清空仓库
				viewmodel.get("store_name").getFromModel().on('afterValueChange', function(data) {
					viewmodel.get('warehouse_name').getFromModel().setValue(null);
				});
				
				
			
			});
			
		}

	}
	try {
		module.exports = ST_st_stockanalysis_filterVM_Extend;
	} catch(error) {

	}
	return ST_st_stockanalysis_filterVM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_stockanalysis_filterVM.Extend.js